import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import StandardModal from 'components/consumer/StandardModal';
import useScreen from 'hooks/useScreen';
import KeySellingPointsBarItem from '../KeySellingPointsBarItem';
import WarrantyIcon from '../icons/WarrantyIcon';
const WarrantyItem = t0 => {
  const $ = _c(11);
  const {
    openMobileModal
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const {
    isMobileOrTablet
  } = useScreen();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <WarrantyIcon color="currentColor" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isMobileOrTablet || $[2] !== openMobileModal) {
    t2 = <KeySellingPointsBarItem icon={t1} onClick={() => {
      if (isMobileOrTablet) {
        openMobileModal({
          content: "This type of coverage applies to all of the foundational elements of your furniture: wood frames, joints, bases, legs, and hardware, which are integral to the life of your product. We promise to pay standard rates for repair if needed or to provide an alternative solution should the issue be unable to be repaired.",
          icon: <WarrantyIcon color="white" />
        });
      } else {
        setIsOpen(true);
      }
    }}>Limited lifetime warranty*</KeySellingPointsBarItem>;
    $[1] = isMobileOrTablet;
    $[2] = openMobileModal;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="KeySellingPointsBarItem-modal-icon"><WarrantyIcon color="white" /></div>;
    t4 = () => {
      setIsOpen(false);
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isOpen) {
    t5 = <StandardModal isOpen={isOpen} icon={t3} onClose={t4} title="Limited lifetime warranty">This type of coverage applies to all of the foundational elements of your furniture: wood frames, joints, bases, legs, and hardware, which are integral to the life of your product. We promise to pay standard rates for repair if needed or to provide an alternative solution should the issue be unable to be repaired.</StandardModal>;
    $[6] = isOpen;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <>{t2}{t5}</>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
WarrantyItem.propTypes = {
  openMobileModal: PropTypes.func
};
export default WarrantyItem;